// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "webConfig/static/css/" + chunkId + "." + {"67":"a9326522","199":"9ee68b37","260":"2ab9debe","299":"4d918973","309":"b0483cc5","321":"109432a5","340":"0f8f8e3e","462":"17b711cd","488":"dbd86f39","633":"dcf3d54c","984":"220432af"}[chunkId] + ".chunk.css";
};